export default __webpack_public_path__ + "locales/lo-LA/EmptyTrashDialog.json?hash=14c91aaa48e9f6b8f5fa0147cb44a2ac";